import { forwardRef, useEffect, useState } from 'react'
import {
    customerHasListOptionValue,
    getMappingitemOptions,
    getPrice,
    LeadFieldName,
    mappingListOptions,
    noOfRecordsField,
    purchaseField,
    returnMailAddOnField,
    undelivarblesField,
} from '../../helpers/slug'
import { MappingFileUpload } from './MappingFileUpload'
import { RadioAccordion } from './RadioAccordion'
import { Text } from './Text'
import CheckBox from './Checkbox'
import Toggle from './Toggle'
import { isMobile } from 'react-device-detect'
import { formatNumberLocal } from '../../helpers/utils'
import { ListBox } from './ListBox'

const MappingListGroup = forwardRef(({ item, setValue, ...props }, ref) => {
    const [selected, setSelected] = useState(null)

    const urlProduct = props.product
    const currentMappingValue = props.getValues?.(item.name)
    const currentLeadFiles = props.getValues?.(LeadFieldName)

    const handleSelect = (e) => {
        setSelected(e.target.value)
        setValue(item.name, e.target.value)
    }

    useEffect(() => {
        if (currentMappingValue && selected !== currentMappingValue) {
            setSelected(currentMappingValue)
            return
        }

        if (
            !currentMappingValue &&
            Array.isArray(currentLeadFiles) &&
            currentLeadFiles.length > 0 &&
            selected !== customerHasListOptionValue
        ) {
            if (selected !== customerHasListOptionValue) {
                setSelected(customerHasListOptionValue)
                setValue(item.name, customerHasListOptionValue)
            }
        }
    }, [currentLeadFiles, currentMappingValue, item.name, selected, setValue])

    useEffect(() => {
        const activeValue = currentMappingValue || selected

        if (activeValue !== customerHasListOptionValue) return

        const currentUndeliverablesValue = props.getValues?.(
            undelivarblesField.name,
        )
        const currentReturnedMailValue = props.getValues?.(
            returnMailAddOnField.name,
        )

        if (typeof currentUndeliverablesValue === 'undefined') {
            setValue(undelivarblesField.name, true)
        }

        if (typeof currentReturnedMailValue === 'undefined') {
            setValue(returnMailAddOnField.name, true)
        }
    }, [currentMappingValue, props, selected, setValue])

    const mayBechangePropsOfItem = (item) => {
        const { purchaseListProduct, getValues } = props

        if (!purchaseListProduct) return item

        const values = getValues()

        const { product: purchaseProduct } = purchaseListProduct

        const noOfRecordsFieldValue = values[noOfRecordsField.name]

        const purchaseFieldQuantity =
            noOfRecordsFieldValue < purchaseField.minQuantity
                ? purchaseField.minQuantity
                : values[noOfRecordsField.name]

        if (noOfRecordsFieldValue && item.name === purchaseField.name) {
            const price =
                '$' +
                formatNumberLocal(
                    Number(purchaseFieldQuantity) *
                        Number(
                            getPrice(purchaseProduct, purchaseFieldQuantity, 1),
                        ),
                    2,
                )
            const text = ` — +${price}`
            item.modifiedLabel = item.label + text
        } else {
            item.modifiedLabel = item.label
        }
        return item
    }

    // const shouldHideInMobile = (option) => (isMobile && option.id == 1) ? true : false

    const itemOptions = (items) => {
        return getMappingitemOptions(items, urlProduct)
    }

    return (
        <div className="mx-auto w-full space-y-2">
            {mappingListOptions.map((option) => {
                return (
                    <RadioAccordion
                        ref={ref}
                        key={option.id}
                        hidden={isMobile && option.id == 1 ? true : false}
                        content={itemOptions(option.items).map((item) => {
                            return (
                                <div key={item.name}>
                                    {item.type === 'leadupload' ? (
                                        <MappingFileUpload
                                            {...{
                                                item,
                                                setValue,
                                                hideListAddOns: true,
                                                ...props,
                                            }}
                                        />
                                    ) : item.type === 'checkbox' ? (
                                        <CheckBox
                                            {...{
                                                item: mayBechangePropsOfItem(
                                                    item,
                                                ),
                                                setValue,
                                                ...props,
                                            }}
                                        />
                                    ) : item.type === 'toggle' ? (
                                        <Toggle
                                            {...{
                                                item: mayBechangePropsOfItem(
                                                    item,
                                                ),
                                                setValue,
                                                ...props,
                                            }}
                                        />
                                    ) : item.type === 'select' ? (
                                        <ListBox
                                            {...{
                                                item,
                                                setParentValue: setValue,
                                                setValue,
                                                ...props,
                                            }}
                                        />
                                    ) : (
                                        // <Lis
                                        //     shouldReset={shouldReset}
                                        //     item={{ ...AddOfferField }}
                                        //     setValue={setValue}
                                        //     errors={errors}
                                        //     getValues={getValues}
                                        // />
                                        <Text
                                            {...{
                                                item,
                                                setValue,
                                                ...props,
                                            }}
                                        />
                                    )}
                                </div>
                            )
                        })}
                        conditionToshow={selected === option.value}
                        defaultChecked={selected === option.value}
                        onClick={handleSelect}
                        name={option.name}
                        label={option.label}
                        value={option.value}
                    />
                )
            })}
        </div>
    )
})

MappingListGroup.displayName = 'MappingListGroup'

export default MappingListGroup
